import { useCallback, useEffect, useRef } from "react";

import { CONFIG_MERCURE_TOPIC, ENVIRONMENT, MERCURE_HUB_URL } from "@/config";
import { useSW } from "@/hooks/app/useSW";

export const useConfigMercure = () => {
    const { getConfig } = useSW();

    const eventSourceRef = useRef<EventSource | null>(null);

    const connect = useCallback(() => {
        if (eventSourceRef.current) {
            eventSourceRef.current.close();
        }

        const url = new URL(MERCURE_HUB_URL);
        url.searchParams.append("topic", CONFIG_MERCURE_TOPIC);

        const eventSource = new EventSource(url.toString());
        eventSourceRef.current = eventSource;

        eventSource.onmessage = (event) => {
            const configUpdatedEvent = `manifest${
                ENVIRONMENT !== "prod" ? "-dev" : ""
            }.updated`;

            console.log("event.data", event.data);

            switch (event.data) {
                case configUpdatedEvent: {
                    getConfig();
                    break;
                }

                default:
                    console.warn("Unknown system event:", event);
            }
        };

        eventSource.onerror = () => {
            console.error("Config Mercure: помилка з'єднання. Закриваємо.");
            eventSource.close();
        };
    }, [getConfig]);

    useEffect(() => {
        connect();

        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                connect();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            eventSourceRef.current?.close();
            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange,
            );
        };
    }, [connect]);
};
